export default __webpack_public_path__ + "static/media/load-balancer.12962bf0.svg";